import { dataAsterisk } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAsterisk = /*#__PURE__*/createIcon(dataAsterisk)
export default IconAsterisk
